import { GoogleDetails } from "../../../types";

type GoogleServiceAreaProps = {
    googleDetails: GoogleDetails;
    title?: string;
    className?: string;
    frameClassName?: string;
    iframeClassName?: string;
}
const GoogleServiceArea = ({
    googleDetails,
    title = "Google service area map",
    className = "relative w-full max-w-4xl mx-auto overflow-hidden group",
    frameClassName = "relative w-full pb-[56.25%]",
    iframeClassName = "absolute top-0 left-0 w-full h-full",
}: GoogleServiceAreaProps) => {

    if (!googleDetails.googleServiceArea) return null;

    return (
        <div className={className}>

            <div className={frameClassName}>
                <iframe
                    title={title}
                    src={googleDetails.googleServiceArea}
                    className={iframeClassName}
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    );
}

export default GoogleServiceArea
